import { render, staticRenderFns } from "./ConfigurarPantallaTransbank.vue?vue&type=template&id=47b38aef&"
import script from "./ConfigurarPantallaTransbank.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarPantallaTransbank.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarPantallaTransbank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('47b38aef', component.options)
    } else {
      api.reload('47b38aef', component.options)
    }
    module.hot.accept("./ConfigurarPantallaTransbank.vue?vue&type=template&id=47b38aef&", function () {
      api.rerender('47b38aef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTransbank/ConfigurarPantallaTransbank.vue"
export default component.exports